import apiClient from "./apiClient";

const inbodyApi = {
  // Subir InBody a nivel de sucursal (nuevo)
  uploadInBody: async (branchId, file, period) => {
    const formData = new FormData();
    formData.append("branchId", branchId);
    formData.append("month", period.month);
    formData.append("year",  period.year);
    formData.append(
      "applicationDate",
      `${period.year}-${String(period.month).padStart(2, "0")}`
    );
    formData.append("file", file, file.name);
    const response = await apiClient.post("/inbody/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  // Por sucursal (nuevo)
  getByBranch: async (branchId) => {
    const response = await apiClient.get(`/inbody/branches/${branchId}`);
    return response.data;
  },

  getPeriodsForBranch: async (branchId) => {
    const response = await apiClient.get(`/inbody/branches/${branchId}/periods`);
    return response.data;
  },

  // Por empresa (backward compat — analytics existentes)
  getByCompany: async (companyId) => {
    const response = await apiClient.get(`/inbody/${companyId}`);
    return response.data;
  },

  getPeriodsForCompany: async (companyId) => {
    const response = await apiClient.get(`/inbody/${companyId}/periods`);
    return response.data;
  },
};

export default inbodyApi;
